const textAlignIcon = (align) => `
<svg viewBox="0 0 512 512" fill="currentColor">
  <path d="M384 106.666c11.782 0 21.334 9.552 21.334 21.334 0 10.94-8.236 19.958-18.846 21.19l-2.488 0.143h-277.334c-11.782 0-21.334-9.552-21.334-21.334 0-10.941 8.236-19.957 18.846-21.19l2.488-0.144h277.334z"></path>
  ${align === 'left'
    ? `
  <path d="M277.334 234.667c11.782 0 21.334 9.552 21.334 21.333 0 10.94-8.236 19.957-18.846 21.19l-2.488 0.144h-170.667c-11.782 0-21.334-9.551-21.334-21.334 0-10.94 8.236-19.958 18.846-21.19l2.488-0.143h170.667z"></path>
  `.trim()
    : ''}
  ${align === 'right'
    ? `
  <path d="M384 234.667c11.782 0 21.334 9.552 21.334 21.333 0 10.94-8.236 19.957-18.846 21.19l-2.488 0.144h-170.667c-11.782 0-21.333-9.551-21.333-21.334 0-10.94 8.236-19.958 18.846-21.19l2.488-0.143h170.666z"></path>
  `.trim()
    : ''}
  ${align === 'center'
    ? `
  <path d="M330.666 234.667c11.782 0 21.334 9.552 21.334 21.333 0 10.94-8.236 19.957-18.846 21.19l-2.488 0.144h-170.667c-11.782 0-21.333-9.551-21.333-21.334 0-10.94 8.236-19.958 18.846-21.19l2.488-0.143h170.667z"></path>
  `.trim()
    : ''}
  ${align === 'justify'
    ? `
  <path d="M384 234.667c11.782 0 21.334 9.552 21.334 21.334 0 10.94-8.236 19.958-18.846 21.19l-2.488 0.143h-277.334c-11.782 0-21.334-9.552-21.334-21.334 0-10.941 8.236-19.957 18.846-21.19l2.488-0.144h277.334z"></path>
  `.trim()
    : ''}
  <path d="M384 362.666c11.782 0 21.334 9.551 21.334 21.334 0 10.94-8.236 19.957-18.846 21.19l-2.488 0.144h-277.334c-11.782 0-21.334-9.551-21.334-21.334 0-10.94 8.236-19.957 18.846-21.19l2.488-0.144h277.334z"></path>
</svg>
`.trim();
export const leftTextAlignIcon = textAlignIcon('left');
export const centerTextAlignIcon = textAlignIcon('center');
export const rightTextAlignIcon = textAlignIcon('right');
export const justifyTextAlignIcon = textAlignIcon('justify');
//# sourceMappingURL=icon.js.map